<div class="page-wrapper">
    <mat-card class="centered-card">
        <mat-toolbar class="justify-content-center" color="primary">Please verify your email</mat-toolbar>
        <form class="p-3">
            <div class="text-center">
                Welcome to KSolve! <br>
            </div>
            <div class="text-center">
                We have sent you an email with a verification code, please enter that below.
            </div>
            <div class="d-flex justify-content-center">
                <mat-form-field>
                    <mat-label>Verification Code</mat-label>
                    <input matInput required [(ngModel)]="verificationCode" name="verificationCode">
                </mat-form-field>
            </div>
            <div class="d-flex justify-content-center">
                <button class="m-2" mat-raised-button type="submit" color="primary"
                    (click)="verifyCode()">Continue</button>
            </div>
            <div class="text-center">
                If you did not receive the code, we can resend it. Please click below...
            </div>
            <div class="text-center">
                <a href="javascript: void(0);" (click)="resendVerificationCode()">Resend email verication code</a>
            </div>
        </form>
    </mat-card>
</div>